module.exports = __webpack_public_path__ + "img/microsite-BR.f2fb702e.gif";